import { Injectable } from '@angular/core';
// import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { StaticDataService } from './static-data.service';
import { Observable, of } from 'rxjs';
import { Config } from '../config/config';

@Injectable()
export class TranslateService {

  pageSize = 10;
  options = StaticDataService.options;

  constructor(private _http: HttpClient, private config: Config) { }

  googleTranslateApi(content, target) {
    const contentData = content;
    const body: any = {};

    body.text = contentData;
    body.source = 'en';
    body.target = target;

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    if (contentData && (contentData !== null) && (contentData.trim() !== '')) {
      return this._http.post(this.config.get('product').baseUrl +'/translate', body, options);
    } else {
      return of({'text': contentData});
    }
  }
}
